import { render, staticRenderFns } from "./GroupMove.vue?vue&type=template&id=397831eb&"
import script from "./GroupMove.vue?vue&type=script&lang=js&"
export * from "./GroupMove.vue?vue&type=script&lang=js&"
import style0 from "./GroupMove.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports